import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ActionsService } from '@modules/search/services/actions.service';
import { SanitizerPipe } from '@shared/pipes/sanitizer.pipe';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Menu, MenuModule } from 'primeng/menu';

@Component({
  selector: 'app-eml-view',
  standalone: true,
  imports: [SanitizerPipe, ButtonModule, MenuModule],
  templateUrl: './eml-view.component.html',
  styleUrl: './eml-view.component.scss',
  // encapsulation: ViewEncapsulation.ShadowDom
})
export class EmlViewComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() emlHtml: any;
  @Input() data: any;
  @Input() viewer: 'iFrame' | 'div' | 'pre' | 'pdf' = 'iFrame';
  @ViewChild('emailFrame') emailFrame!: ElementRef;
  @ViewChild('textSelectionMenu') textSelectionMenu!: Menu;
  @Input() emlHeight = 'calc(100vh - var(--topNav-height) - 15.67rem)';
  interval: any;
  items: MenuItem[] | undefined;
  selectedText: string = '';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private _action: ActionsService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnInit(): void {
    this.items = [
      {
        label: 'Copy selection',
        icon: 'pi pi-copy',
        style: { padding: '0' },
        command: () => {
          this.copySelection();
        },
      },
      {
        label: 'Simplify and explain ✨',
        icon: 'pi pi-question-circle',
        style: { padding: '0' },
        command: () => {
          this.addToAiContextAndExplain();
        },
      },
    ];
  }

  ngAfterViewInit(): void {}

  onLoad(): void {
    if (!this.emailFrame) {
      return;
    }
    const iframe = this.emailFrame.nativeElement as HTMLIFrameElement;
    const iframeDocument =
      iframe.contentDocument || iframe.contentWindow?.document;

    if (iframeDocument) {
      iframeDocument.addEventListener('mouseup', (event: MouseEvent) => {
        if (iframeDocument.getSelection()?.type === 'Range') {
          const selectedText = iframeDocument.getSelection()?.toString();
          if (selectedText) {
            this.selectedText = selectedText;
            setTimeout(() => {
              this.showTextSelectionMenu(event);
            }, 200);
          }
        } else {
          this.selectedText = '';
          this.textSelectionMenu.hide();
        }
      });
    }
  }

  showTextSelectionMenu(event: MouseEvent): void {
    let target = event.target as HTMLElement;

    const iframe = this.emailFrame.nativeElement as HTMLIFrameElement;
    const iframeRect = iframe.getBoundingClientRect();

    const button = this.document.createElement('button');
    button.textContent = '';
    button.style.display = 'block';
    button.style.position = 'fixed';
    button.style.top = `${iframeRect.y + event.y}px`;
    button.style.left = `${iframeRect.x + event.x}px`;

    button.addEventListener('click', (buttonEvent) => {
      this.textSelectionMenu.hide();
      this.textSelectionMenu.show(buttonEvent);
      setTimeout(() => {
        button.remove();
      }, 0);
    });

    target.appendChild(button);
    button.click();
  }

  copySelection(): void {
    navigator.clipboard.writeText(this.selectedText);
  }

  addToAiContext(): void {
    this._action.addToAiContext(this.selectedText);
  }

  addToAiContextAndExplain(): void {
    this._action.addToAiContextAndExplain(this.selectedText);
  }
}
